import { Alert, ChecklistTask, Order, PaymentMethod, Product, Purchase, CustomerProfile } from "@/types";

export const initialProducts: Product[] = [
  { id: "p1", name: "Coca-Cola Lata", category: "Bebidas", price: 8.9, door: "B-03", qrCode: "TP-DOOR-B03", tag: "Mais pedido", stock: 18, minStock: 6 },
  { id: "p2", name: "Água com gás", category: "Bebidas", price: 5.9, door: "B-01", qrCode: "TP-DOOR-B01", tag: "Rápido", stock: 22, minStock: 8 },
  { id: "p3", name: "Red Bull", category: "Bebidas", price: 16.9, door: "B-05", qrCode: "TP-DOOR-B05", tag: "Premium", stock: 4, minStock: 6 },
  { id: "p4", name: "KitKat", category: "Doces", price: 6.9, door: "D-02", qrCode: "TP-DOOR-D02", tag: "Impulso", stock: 12, minStock: 5 },
  { id: "p5", name: "Doritos", category: "Snacks", price: 10.9, door: "S-04", qrCode: "TP-DOOR-S04", tag: "Snack", stock: 9, minStock: 5 },
  { id: "p6", name: "Escova de dente", category: "Higiene", price: 11.9, door: "H-01", qrCode: "TP-DOOR-H01", tag: "Emergência", stock: 7, minStock: 3 },
];

export const initialOrders: Order[] = [
  { id: "#001", customer: "Bernardo", productName: "Coca-Cola Lata", amount: 8.9, status: "Pago", date: "Hoje · 09:14" },
  { id: "#002", customer: "Fernanda", productName: "Água com gás", amount: 5.9, status: "Pago", date: "Hoje · 10:42" },
  { id: "#003", customer: "Yann", productName: "Red Bull", amount: 16.9, status: "Pendente", date: "Hoje · 11:20" },
];

export const initialAlerts: Alert[] = [
  {
    id: "a1",
    title: "Estoque baixo: Red Bull",
    summary: "Apenas 4 unidades restantes na porta B-05",
    description: "O item Red Bull está abaixo do estoque mínimo de 6 unidades. Recomenda-se reposição imediata para evitar ruptura na operação.",
    type: "Estoque",
    suggestion: "Reabastecer 12 unidades na porta B-05 até o fim do dia.",
    severity: "high",
  },
  {
    id: "a2",
    title: "Falha de abertura — Porta D-02",
    summary: "Cliente relatou que a porta não destravou na 1ª tentativa",
    description: "A porta D-02 apresentou atraso de resposta no comando de abertura. Verificar conexão do módulo e firmware.",
    type: "Operacional",
    suggestion: "Realizar teste de abertura manual e checar log do módulo IoT.",
    severity: "medium",
  },
  {
    id: "a3",
    title: "Pagamento pendente — Pedido #003",
    summary: "Pagamento de R$ 16,90 ainda não confirmado",
    description: "O cliente Yann retirou o item, porém o pagamento permanece pendente há mais de 30 minutos.",
    type: "Pagamento",
    suggestion: "Enviar lembrete automático e aguardar 1h antes de bloquear a conta.",
    severity: "medium",
  },
];

export const initialPaymentMethods: PaymentMethod[] = [
  { id: "pm1", type: "Cartão", label: "Visa •••• 4521", isDefault: true },
  { id: "pm2", type: "Pix", label: "Pix · CPF cadastrado", isDefault: false },
];

export const initialChecklist: ChecklistTask[] = [
  { id: "c1", title: "Conferir estoque crítico", done: false },
  { id: "c2", title: "Validar QR Codes das portas", done: true },
  { id: "c3", title: "Testar portas principais", done: false },
  { id: "c4", title: "Revisar limpeza e organização", done: false },
  { id: "c5", title: "Conferir pagamentos com falha", done: true },
];

export const initialPurchases: Purchase[] = [
  { id: "h1", productName: "Coca-Cola Lata", amount: 8.9, date: "Hoje · 09:14", door: "B-03" },
  { id: "h2", productName: "KitKat", amount: 6.9, date: "Ontem · 22:08", door: "D-02" },
  { id: "h3", productName: "Água com gás", amount: 5.9, date: "Ontem · 18:31", door: "B-01" },
];

export const initialCustomer: CustomerProfile = {
  name: "Bernardo Lima",
  apartment: "1204",
  building: "Yacht Tower · Balneário Camboriú",
  email: "bernardo@takepay.app",
  phone: "(47) 99999-1204",
  initials: "BL",
  status: "Ativa",
};
